<template>
  <div class="depot">
    <headerNotice routerName="仓库列表"></headerNotice>
    <!-- 搜索框 -->
    <div class="seach-box">
      <h2 class="title">
        <i></i>
        <span>筛选查询</span>
      </h2>
      <div class="input-wrapper">
        <div>
          <span>输入搜索：</span>
          <el-input class="el-search" clearable v-model="searchWord" placeholder="仓库名称/仓库编号"></el-input>
        </div>
        <div class="status">
          <span>仓库状态：</span>
          <el-select v-model="status">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <el-button @click="toSearch">查询</el-button>
      </div>
    </div>
    <!-- 仓库列表 -->
    <div class="depot-list">
      <div class="head">
        <h2 class="title">
          <i></i>
          <span>数据列表</span>
        </h2>
        <div class="control">
          <el-button class="tip-box" @click="toAddDepot">添加</el-button>
          <!-- <el-button class="tip-box">ERP同步</el-button> -->
          <!-- <el-select class='select-box' v-model="value" placeholder="显示条数">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <el-select class='select-box' v-model="value" placeholder="排序方式">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>-->
        </div>
      </div>
      <!-- 覆盖地址弹出框 -->
      <el-dialog v-loading="loading" title="覆盖地址:" :visible.sync="showAreaBox">
        <el-tree
          v-loading="regionLoading"
          :data="reginData"
          show-checkbox
          node-key="code"
          :default-checked-keys="areaTreeKeys"
          accordion
          :props="defaultProps"
          ref="areaTree"
        ></el-tree>
      </el-dialog>
      <!-- 收货地址弹出框 -->
      <div class="add-box">
        <el-dialog
          v-loading="loading"
          :title="dialogTitle"
          :visible.sync="showAddBox"
          width='800px'
        >
          <el-form ref="form" :rules="rules" class="from-el" :model="form" label-width="98px">
            <el-form-item prop="houseName" label="仓库名称:">
              <el-input
                placeholder="请输入仓库名称"
                class="input-el"
                v-model="form.houseName"
                autocomplete="off"
                maxlength="15"
              ></el-input>
            </el-form-item>
            <el-form-item prop="houseCode" label="仓库编号:">
              <el-input
                placeholder="请输入仓库编号"
                class="input-el"
                v-model="form.houseCode"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item prop="linkman" label="联系人:">
              <el-input
                placeholder="请输入联系人"
                class="input-el"
                v-model="form.linkman"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item prop="phone" label="联系电话:">
              <el-input
                placeholder="请输入联系电话"
                class="input-el"
                v-model="form.phone"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item
              v-if="divisionID == 0"
              v-loading="userListLoading"
              :rules="{required: true}"
              label="仓库管理员:"
            >
              <!-- <el-select v-model="form.userID" placeholder="请选择仓库管理员">
                <el-option
                  v-for="item in userList"
                  :key="item.userID"
                  :label="item.userName"
                  :value="item.userID"
                ></el-option>
              </el-select>-->
              <el-select class="input-el" v-model="warehouseKeeper" multiple placeholder="请选择仓库管理员">
                <el-option
                  v-for="item in userList"
                  :key="item.userID"
                  :label="item.userName"
                  :value="item.userID"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-loading="regionLoading" prop="areaCode" label="仓库地区:">
              <el-cascader
                class="input-el"
                :options="reginData"
                :props="cascaderProps"
                v-model="form.areaCode"
              ></el-cascader>
            </el-form-item>
            <el-form-item prop="address" label="仓库地址:">
              <el-input
                placeholder="请输入仓库地址"
                type="textarea"
                resize="none"
                class="input-el"
                v-model="form.address"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <!-- <el-form-item v-loading="areaLoading" prop="logisticsID" label="所发物流:">
              <el-select class="input-el" v-model="form.logisticsID" placeholder="请选择物流公司">
                <el-option
                  v-for="item in logistics"
                  :key="item.logisticsID"
                  :label="item.logisticsName"
                  :value="item.logisticsID"
                ></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item prop="logistics" label="物流信息:">
                <div style='border: 1px solid #dcdfe6; border-radius: 4px;'>
                    <el-table :data="form.logistics" max-height='260'>
                        <el-table-column prop="logisticsID" label="物流公司" width='220px' align='center'>
                            <template slot-scope="scope">
                                <el-select @change='logisticsIDChange(scope.$index)' v-model="scope.row.logisticsID" placeholder="请选择物流公司">
                                    <el-option
                                    v-for="item in logistics"
                                    :key="item.logisticsID"
                                    :label="item.logisticsName"
                                    :value="item.logisticsID"
                                    ></el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column prop="customerName" label="签约用户" align='center'>
                            <template slot-scope="scope">
                                <el-input :disabled="!form.logistics[scope.$index].logisticsID" v-model='scope.row.customerName'></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column prop="customerPwd" label="签约密码" align='center'>
                            <template slot-scope="scope">
                                <el-input :disabled="!form.logistics[scope.$index].logisticsID" v-model='scope.row.customerPwd'></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column prop="isDefault" label="是否默认"  width='100px' align='center'>
                            <template slot-scope="scope">
                                <el-checkbox :disabled="!form.logistics[scope.$index].logisticsID" v-model='scope.row.isDefault' 
                                :true-label='1' :false-label='0' @change="setDefault(scope.$index)"></el-checkbox>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <el-row style='padding: 10px 0 0 35%;'>
                    <el-button @click='editLogistics(0)'>删除物流</el-button>
                    <el-button @click='editLogistics(1)' type="primary">添加物流</el-button>
                </el-row>
            </el-form-item>
            <el-form-item prop="areaCodes" label="覆盖范围:">
              <el-container
                v-loading="regionLoading"
                style="height: 220px; border: 1px solid #dcdfe6; border-radius: 4px;"
              >
                <el-main style='padding: 10px;'>
                  <el-tree
                    :data="reginData"
                    show-checkbox
                    node-key="code"
                    :default-checked-keys="defaultKeys"
                    accordion
                    :props="defaultProps"
                    ref="reginTree"
                    @check="setAreaCodes"
                  ></el-tree>
                </el-main>
              </el-container>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="showAddBox = false">取 消</el-button>
            <el-button :loading="btnLoading" type="primary" @click="checkForm">确 定</el-button>
          </div>
        </el-dialog>
      </div>
      <!-- 表格 -->
      <el-table
        v-loading="loading"
        ref="multipleTable"
        :data="depotList"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column align="center" type="selection" width="55"></el-table-column>
        <el-table-column align="center" prop="houseName" label="仓库名称" width="120"></el-table-column>
        <el-table-column align="center" prop="houseCode" label="仓库编号" width="120"></el-table-column>
        <el-table-column align="center" prop="address" label="仓库地址"></el-table-column>
        <el-table-column align="center" prop="linkman" label="联系人" width="180"></el-table-column>
        <el-table-column align="center" prop="phone" label="联系电话" width="180"></el-table-column>
        <el-table-column align="center" prop="logistics" label="发货物流公司" width="180"></el-table-column>
        <el-table-column align="center" label="状态" width="180">
          <template slot-scope="scope">{{ scope.row.stutus | statusFilter}}</template>
        </el-table-column>
        <el-table-column align="center" prop="address" label="操作" width="250">
          <template slot-scope="scope">
            <el-button @click="toEditDepot(scope.row)" type="text" size="small">修改</el-button>
            <el-button @click="toUse(scope.row)" type="text" size="small">启用</el-button>
            <el-button @click="toStop(scope.row)" type="text" size="small">禁用</el-button>
            <el-button @click="toGetLogistics(scope.row)" type="text" size="small">查看覆盖范围</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 多选操作 -->
    <div style="margin-top: 20px; margin-left: 50px">
      <el-button @click="toggleSelection(1)">批量启用</el-button>
      <el-button @click="toggleSelection(0)">批量禁用</el-button>
      <!-- <el-button @click="toggleSelection()">批量删除</el-button> -->
    </div>
    <!--分页-->
    <div class="pagination-wrapper">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
        center
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import headerNotice from "./../../components/common/headerNotice.vue";

export default {
  components: {
    headerNotice
  },
  props: {},
  data() {
    var checkTel = (rule, value, callback) => {
      if (!/^1[34578]\d{9}$/.test(value)) {
        return callback(new Error("请输入正确的联系电话"));
      } else {
        callback();
      }
    };
    var checkAreaCodes = (rule, value, callback) => {
      if (!this.$refs.reginTree.getCheckedKeys().length) {
        return callback(new Error("请勾选覆盖地区"));
      } else {
        callback();
      }
    };
    var checkUser = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请选择仓库管理员"));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      areaLoading: false,
      regionLoading: false,
      userListLoading: false,
      btnLoading: false,
      iscreat: false,
      pageSize: 10,
      currentPage: 1,
      SkipCount: 0,
      totalCount: 0,
      depotList: [],
      dialogTitle: "",
      searchWord: "",
      status: "",
      divisionID: 0,
      reginData: [],
      defaultKeys: [],
      defaultProps: {
        children: "children",
        value: "code",
        label: "name"
      },
      cascaderProps: {
        children: "children",
        label: "name",
        value: "code"
      },
      areaTreeKeys: [],
      showAreaBox: false,
      userList: [],
      logistics: [],
      // areaCode: [],
      form: {
        userIDs: "",
        logistics: []
      },
      warehouseKeeper: [], //仓库管理员
      showAddBox: false,
      options: [
        {
          value: "",
          label: "全部"
        },
        {
          value: 1,
          label: "已启用"
        },
        {
          value: 0,
          label: "已禁用"
        }
      ],
      selections: [],
      rules: {
        houseName: [
          { required: true, message: "请输入仓库名称", trigger: "blur" }
        ],
        houseCode: [
          { required: true, message: "请输入仓库编号", trigger: "blur" }
        ],
        address: [
          { required: true, message: "请输入仓库地址", trigger: "blur" }
        ],
        linkman: [{ required: true, message: "请输入联系人", trigger: "blur" }],
        phone: [{ required: true, validator: checkTel, trigger: "blur" }],
        // logisticsID: [
        //   { required: true, message: "请选择快递公司", trigger: "blur" }
        // ],
        logistics: [
          { required: true, message: "请添加物流信息" }
        ],
        areaCodes: [
          { required: true, validator: checkAreaCodes, trigger: "blur" }
        ],
        areaCode: [
          { required: true, message: "请选择仓库地区", trigger: "blur" }
        ]
        // userID: [{ required: true, validator: checkUser, trigger: "blur" }],
      }
    };
  },
  watch: {
    showAddBox(val) {
      if (!val) {
        this.$refs.form.resetFields();
        this.form.userIDs = "";
        this.warehouseKeeper = [];
        this.defaultKeys = [];
        this.$refs.reginTree.setCheckedKeys([]);
      }
    }
  },
  computed: {},
  methods: {
    getData(params) {
      let self = this;
      self.areaLoading = true;
      $http.GET({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/LogisticsService/GetAllLogistics",
        params: params,
        success(res) {
          // console.log(res);
          self.loading = false;
        },
        fail(res) {
          self.loading = false;
        }
      });
    },
    // 物流信息校验
    checkLogistics() {
      if (!this.form.logistics.length) {
        this.$message.error('请添加物流信息')
        return false;
      } else {
        let logistics = this.form.logistics
        let count = 0
        for(let i = 0; i < logistics.length; i++) {
            if(!logistics[i].logisticsID && logistics[i].logisticsID !== 0) {
                this.$message.error(`请选择第${i+1}项的物流公司`) 
                return false 
            } else if(!logistics[i].customerName || !logistics[i].customerPwd){
                this.$message.error(`请填写第${i+1}项的物流信息`)
                return false
            } else {
                count += 1
            }
        }
        if(count == logistics.length) {
            let hasDefault = logistics.some((item) => {
                 return item.isDefault == 1
            })
            if(!hasDefault) {
                this.$message.error(`请设置默认物流公司`)
                return false
            } else {
                return true
            }
        }
      }
    },
    // 增删物流公司
    editLogistics(type) {
        if(type) {
            this.form.logistics.push({
                logisticsID: null,
                customerName: "",
                customerPwd: "",
                isDefault: 0
            })
        } else {
            this.form.logistics.pop()
        }
    },
    // 设置默认物流
    setDefault(i) {
        this.form.logistics.forEach((item, index) => {
            if(index == i) {
                item.isDefault = 1
            } else {
                item.isDefault = 0
            }
        })
    },
    // 切换物流公司清除签约信息
    logisticsIDChange(i) {
        this.form.logistics[i].customerName = ''
        this.form.logistics[i].customerPwd = ''
    },
    // 点击启用
    toUse(row) {
      this.enableWarehouse({ houseIDs: [row.houseID], active: 1 });
    },
    // 点击禁用
    toStop(row) {
      this.enableWarehouse({ houseIDs: [row.houseID], active: 0 });
    },
    // 修改仓库状态
    enableWarehouse(data) {
      let self = this;
      $http.POST({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/Warehouse/EnableWarehouse",
        data: data,
        success(res) {
          // console.log(res);
          self.toSearch();
        },
        fail(res) {}
      });
    },
    // 筛选覆盖范围
    // filterNode(val, data) {},
    // 点击覆盖范围
    toGetLogistics(row) {
      this.showAreaBox = true;
      this.getLogisticsByHouseId({ houseid: row.houseID });
    },
    // 获取覆盖范围
    getLogisticsByHouseId(params) {
      let self = this;
      self.loading = true;
      $http.GET({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/Warehouse/GetWarehouseAreas",
        params: params,
        success(res) {
          // console.log(res);
          self.$refs.areaTree.setCheckedKeys([]);
          self.areaTreeKeys = res;
          self.loading = false;
          // self.memberList = self.dealMemberList(res)
        },
        fail(res) {
          self.loading = false;
        }
      });
    },
    // 更新仓库状态
    updateWareHouse() {
      let self = this;
      // self.btnLoading = true
      let form = Object.assign({}, self.form);
      form.areaCode = self.form.areaCode[2];
      form.userIDs = self.warehouseKeeper;
      // if (this.divisionID == 0) {
      if (!form.userIDs) {
        this.$message.error("请选择仓库管理员");
      }
      // }
      if(!(this.checkLogistics())) return
      $http.PUT({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/Warehouse/UpdateWareHouse",
        data: form,
        success(res) {
          self.$message({
            message: "修改成功",
            type: "success"
          });
          self.btnLoading = false;
          self.showAddBox = false;
          self.toSearch();
        },
        fail(res) {
          self.btnLoading = false;
        }
      });
    },
    // 点击编辑按钮
    toEditDepot(row) {
      // console.log(row)
      this.dialogTitle = "编辑仓库:";
      this.iscreat = false;
      this.getWarehouseDetails({ houseid: row.houseID });
    },
    // 获取列表详情
    getWarehouseDetails(params) {
      let self = this;
      $http.GET({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/Warehouse/GetWarehouseDetails",
        params: params,
        success(res) {
          // console.log(res);
          if (!res) {
            self.showAddBox = true;
            return;
          }
          let areaCode = [];
          areaCode.push(Number(res.provinceCode));
          areaCode.push(Number(res.cityCode));
          areaCode.push(Number(res.areaCode));
          self.divisionID = res.divisionID;
          // console.log(areaCode);
          // console.log(Object.assign({}, res, {areaCode: areaCode}))
          self.showAddBox = true;
          self.form = Object.assign({}, res, { areaCode: areaCode });
          // console.log(self.form);
          // self.$refs.reginTree.setCheckedKeys([]);
          self.defaultKeys = res.areaCodes;
          // self.$forceUpdate();
          // console.log(self.form, self.defaultKeys)
          for (var i = 0; i < res.houseUser.length; i++) {
            self.warehouseKeeper.push(res.houseUser[i].userID);
          }
          // console.log(self.warehouseKeeper);
        },
        fail(res) {
          // self.loading = false;
        }
      });
    },
    // 检查表格数据
    checkForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          // console.log(this.form);
          if (this.iscreat) {
            this.createWareHouse();
          } else {
            this.updateWareHouse();
          }
        } else {
          // console.log(this.form);
          this.$message({
            showClose: true,
            message: "请正确填写必填项！",
            type: "warning"
          });
          return false;
        }
      });
    },
    // 设置地区
    setAreaCodes() {
      this.form.areaCodes = this.$refs.reginTree.getCheckedKeys();
      // console.log(this.form.areaCodes);
    },
    // 点击添加按钮
    toAddDepot() {
      this.dialogTitle = "添加仓库:";
      this.divisionID = 0;
      this.showAddBox = !this.showAddBox;
      this.iscreat = true;
    },
    // 创建仓库
    createWareHouse() {
      let self = this;
    //   self.btnLoading = true;
      let form = Object.assign({}, self.form);
      // console.log(form, this.form);
      form.areaCode = self.form.areaCode[2];
      form.userIDs = self.warehouseKeeper;
      // if (this.divisionID == 0) {
      if (!form.userIDs) {
        this.$message.error("请选择仓库管理员");
      }
      // }
      if(!(this.checkLogistics())) return
      $http.POST({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/Warehouse/CreateWareHouse",
        data: form,
        success(res) {
          self.$message({
            message: "添加成功",
            type: "success"
          });
          self.btnLoading = false;
          self.showAddBox = false;
          self.toSearch();
        },
        fail(res) {
          self.btnLoading = false;
        }
      });
    },
    // 获取用户列表
    getAdminUserList() {
      let self = this;
      self.userListLoading = false;
      $http.GET({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminUser/GetAdminUserList",
        // params: params,
        success(res) {
          // console.log(res);
          self.userList = res;
          self.userListLoading = false;
        },
        fail(res) {
          self.userListLoading = false;
        }
      });
    },
    // 获取物流公司
    getAllLogistics(params) {
      let self = this;
      self.areaLoading = false;
      $http.GET({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminLogistics/GetAllLogistics",
        params: params,
        success(res) {
          // console.log(res);
          self.logistics = res;
          self.areaLoading = false;
        },
        fail(res) {
          self.areaLoading = false;
        }
      });
    },
    //获取所有省市区数据
    getAllRegin() {
      let self = this;
      self.regionLoading = true;
      $http.GET({
        url:
          this.$store.state.apiUrl + "/api/services/app/Province/GetAllRegion",
        success(res) {
          // console.log(res);
          self.reginData = res;
          self.regionLoading = false;
          // self.btnLoading = false;
          // console.log(self.areaCode)
        },
        fail(res) {
          self.regionLoading = false;
          // self.btnLoading = false;
        }
      });
    },
    // 获取仓库数据
    getWareHouseList(params) {
      let self = this;
      self.loading = true;
      $http.GET({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/Warehouse/GetWareHouseList",
        params: params,
        success(res) {
          // console.log(res);
          self.depotList = res.items;
          self.totalCount = res.totalCount;
          self.loading = false;
        },
        fail(res) {
          self.loading = false;
        }
      });
    },
    // 搜索
    toSearch() {
      let val = this.status;
      if (val == 2) {
        val = "";
      }
      let params = {
        Status: val,
        Keyword: this.searchWord,
        MaxResultCount: this.pageSize,
        SkipCount: 0
      };
      this.getWareHouseList(params);
      this.currentPage = 1;
    },
    // 表格checkbox
    handleSelectionChange(val) {
      this.selections = val;
    },
    // 批量启、禁用
    toggleSelection(status) {
      // console.log(this.selections)
      if (!this.selections.length) {
        this.$message.error("请至少勾选一项");
        return;
      }
      let slectItem = [];
      this.selections.forEach(item => {
        slectItem.push(item.houseID);
      });
      this.enableWarehouse({ houseIDs: slectItem, active: status });
    },
    //一页显示多少个
    handleSizeChange(val) {
      this.pageSize = val;
      let params = {
        MaxResultCount: val,
        Status: this.status,
        Keyword: this.searchWord
      };
      this.getWareHouseList(params);
    },
    //跳转到指定页
    handleCurrentChange(val) {
      // this.loading = true;
      let skipCount = (val - 1) * this.pageSize;
      let params = {
        SkipCount: skipCount,
        MaxResultCount: this.pageSize,
        Status: this.status,
        Keyword: this.searchWord
      };
      this.getWareHouseList(params);
    }
  },
  filters: {
    statusFilter(status) {
      return status ? "已启用" : "已禁用";
    }
  },
  created() {
    this.getWareHouseList({
      MaxResultCount: this.pageSize
    });
  },
  mounted() {
    this.getAllLogistics();
    this.getAllRegin();
    this.getAdminUserList();

    // this.getWarehouseDetails({houseid: 6})
    // this.enableWarehouse({houseid: 1, active: 0},{houseid: 2, active: 0},{houseid: 3, active: 0})
  }
};
</script>
<style lang="scss" scoped>
.depot {
  // 搜索
  .seach-box {
    border: 1px solid rgba(228, 228, 228, 1);
    margin: 20px 50px;
    .title {
      display: flex;
      align-items: center;
      height: 50px;
      font-weight: 400;
      background-color: rgba(243, 243, 243, 1);
      border-bottom: 1px solid rgba(228, 228, 228, 1);
      padding-left: 20px;
      // i:first-child {
      //   width: 18px;
      //   height: 18px;
      //   background: green;
      // }
    }
    .input-wrapper {
      display: flex;
      align-items: center;
      height: 60px;
      padding-left: 40px;
      .el-search {
        width: 180px;
      }
      .status {
        margin-left: 40px;
        margin-right: 40px;
      }
    }
  }

  // 仓库列表
  .depot-list {
    margin: 0 50px;
    border: 1px solid rgba(228, 228, 228, 1);
    font-weight: 400;
    .head {
      display: flex;
      align-items: center;
      justify-content: space-between;
      background-color: rgba(243, 243, 243, 1);
      border-bottom: 1px solid rgba(228, 228, 228, 1);
      .title {
        display: flex;
        align-items: center;
        height: 50px;
        font-weight: 400;
        padding-left: 20px;
        // i:first-child {
        //   width: 18px;
        //   height: 18px;
        //   background: green;
        // }
      }
    }
    .control {
      .tip-box {
        width: 80px;
        padding-left: 0;
        padding-right: 0;
        margin-right: 20px;
      }
      .select-box {
        width: 100px;
        margin-left: 20px;
      }
    }
    // 弹出框
    .add-box {
      // width: 600px;
      // /deep/ .el-dialog__header {
      //   display: flex;
      //   align-items: center;
      //   padding-top: 14px;
      //   background: rgba(242, 242, 242, 1);
      //   font-weight: 700;
      // }
      // .from-el {
      //     width: 600px;
      // }
      .input-el {
        width: 400px;
      }
    }
  }
  .pagination-wrapper {
    text-align: center;
    margin-top: 20px;
  }
}
</style>